import { render, staticRenderFns } from "./bindCustomerAddress.vue?vue&type=template&id=a59e0be0&scoped=true&"
import script from "./bindCustomerAddress.vue?vue&type=script&lang=js&"
export * from "./bindCustomerAddress.vue?vue&type=script&lang=js&"
import style0 from "./bindCustomerAddress.vue?vue&type=style&index=0&id=a59e0be0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59e0be0",
  null
  
)

export default component.exports